import { Formik, useField } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { FieldControl, Form, SingleSelect } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import ExpenseItemDetails from './ExpenseItemDetails';
import { BulkActionModal } from '~/components/bulk-action';

export default function BulkSetReimbursed({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Set Reimbursed"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={ExpenseItemDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ reimbursed: null }}
        onSubmit={async (values) => {
          const body = { isReimbursed: values.reimbursed === 'yes' };
          return api.www
            .workspaces(workspace.id)
            .expenseAdmin()
            .bulkSetIsReimbursed(ids, body)
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          reimbursed: Yup.string().label('Reimbursed').nullable().required(),
        })}>
        {() => {
          return (
            <Form>
              <p>
                Set the reimbursed status of {ids.length} {pluralize('expense item', ids.length)} to:
              </p>

              <Form.Control>
                <FieldReimbursedSelect name="reimbursed" />
              </Form.Control>
            </Form>
          );
        }}
      </Formik>
    </BulkActionModal>
  );
}

function FieldReimbursedSelect(props) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <FieldControl error={error}>
      <SingleSelect placeholder="Reimbursed" {...field} {...props}>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </SingleSelect>
    </FieldControl>
  );
}
